import { makeStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Locale } from 'localization/locale';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import supportedLocales from 'localization/supportedLocales';
import styled from 'styled-components';

const Container = styled.div`
  padding: 15px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

interface LanguageSwitcherProps {
  companyLanguages: string[];
}

const LanguageSwitcher: FC<LanguageSwitcherProps> = ({ companyLanguages }) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  if (companyLanguages.length > 0 && !companyLanguages.includes(i18n.language))
    i18n.changeLanguage(companyLanguages[0]);
  return (
    <Container>
      <Select
        value={i18n.language}
        defaultValue={i18n.language}
        disableUnderline={true}
        classes={{
          root: classes.selectorRoot,
          select: classes.selectorRoot
        }}
        onClose={() => {
          setTimeout(() => {
            if (document.activeElement instanceof HTMLElement)
              document.activeElement.blur();
          }, 0);
        }}
        onChange={e => {
          if (typeof e.target.value === 'string')
            i18n.changeLanguage(e.target.value);
        }}
      >
        {supportedLocales
          .filter(l =>
            companyLanguages.length > 0
              ? companyLanguages.includes(l.code)
              : true
          )
          .map((locale: Locale, index: number) => (
            <MenuItem key={index} value={locale.code}>
              {locale.name}
            </MenuItem>
          ))}
      </Select>
    </Container>
  );
};

const useStyles = makeStyles(() => ({
  selectorRoot: {
    border: '0px !important',
    borderRadius: '10px',
    backgroundColor: 'white !important',
    fontFamily: 'Montserrat, sans-serif !important;',
    fontSize: '13px',
    paddingLeft: 10,
    position: 'relative',
    '& .MuiInputBase-input:focus': {
      border: '0px !important'
    }
  }
}));
export default LanguageSwitcher;
